// export const host = "http://localhost:5001/api/"
// export const adminhost = "http://localhost:5000/api/admin/"
export const host = "https://approval.tnlea.com/api/"
export const adminhost = "https://approval.tnlea.com/api/admin/"


